export const DETAILED_ROW_HORIZONTAL_PADDING_PX = 18;

// Responsive values are set by personView.layout.css on the row list.
export const DETAILED_ROW_COLUMN_GAP =
  "var(--time-report-detailed-column-gap, 32px)";

export function getDetailedGridColumns(hasDeviation: boolean): string {
  return `
  minmax(var(--time-report-identity-width, 300px), 2.3fr)
  repeat(2, minmax(var(--time-report-time-width, 120px), 1fr))
  minmax(var(--time-report-reported-width, 284px), 1fr)
  minmax(122px, 1fr)
  minmax(110px, 1fr)
  ${
    hasDeviation
      ? "repeat(2, minmax(var(--time-report-status-metric-width, 96px), 1fr))"
      : "minmax(var(--time-report-status-width, 224px), 2fr)"
  }
  72px
`;
}
